(()=>{
    function openTargetDetails(hash) {
        if (!hash.startsWith('#')) return;
        const target = document.getElementById(hash.slice(1));
        if (target instanceof HTMLDetailsElement) target.open = true;
    }
    document.addEventListener('click', (event)=>{
        if (!(event.target instanceof Element)) return;
        const link = event.target.closest('a[href^="#"]');
        if (link) openTargetDetails(link.hash);
    });
    window.addEventListener('hashchange', ()=>openTargetDetails(window.location.hash));
    openTargetDetails(window.location.hash);
})();

//# sourceMappingURL=details-target.a639bcf8.js.map
